var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("span", { staticClass: "stit" }, [_vm._v(_vm._s(_vm.data[2]))]),
    _vm._v(" " + _vm._s(_vm.data[0]) + " (" + _vm._s(_vm.data[1]) + ") ")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }